const UPDATE_REQUEST_STATUS = 'UPDATE_REQUEST_STATUS';
const GET_INVITED_CHILD_INFO = 'GET_INVITED_CHILD_INFO';
const SET_POPUP_STEP = 'SET_POPUP_STEP';
const SET_POPUP_STATUS = 'SET_POPUP_STATUS';
const SET_POPUP_LOADING = 'SET_POPUP_LOADING';

export {
  UPDATE_REQUEST_STATUS,
  GET_INVITED_CHILD_INFO,
  SET_POPUP_STEP,
  SET_POPUP_STATUS,
  SET_POPUP_LOADING,
};
